<div class="container-fluid p-0">
    <nav>
        <ul class="nav nav-tabs">
            <li class="nav-item pe-1">
                <a class="nav-link" jhiTranslate="audit.germplasm-progenitors.nav.details"
                   [routerLink]="['details']" [routerLinkActive]="['active']" queryParamsHandling="merge">Details</a>
            </li>
            <li class="nav-item pe-1">
                <a class="nav-link" jhiTranslate="audit.germplasm-progenitors.nav.other-progenitors"
                   [routerLink]="['other-progenitors']" [routerLinkActive]="['active']" queryParamsHandling="merge">Other Progenitors</a>
            </li>
        </ul>
    </nav>
    <div class="tab-content p-3">
        <router-outlet></router-outlet>
    </div>
</div>
